export const LAST_SELECTED_CODE_LANGUAGE = 'last_selected_code_language';
export const DEFAULT_CODE_LANGUAGE = 'Plain Text';
